import { render, staticRenderFns } from "./internalstock_transfer.vue?vue&type=template&id=738df7a5&"
import script from "./internalstock_transfer.vue?vue&type=script&lang=js&"
export * from "./internalstock_transfer.vue?vue&type=script&lang=js&"
import style0 from "./internalstock_transfer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports